/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const styles = (theme) => ({
    primaryButtonActive: {
        backgroundColor: '#a1001a',
        color: theme.palette.white,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '9px 16px',
        borderRadius: '30px',
        boxShadow: 'none',
        margin: '16px 6px 0 0',
        '@media screen and (max-width: 400px)': {
            fontSize: '12px',
            padding: '5px 16px',
        },
        '@media screen and (min-width: 768px)': {
            fontSize: '16px',
            padding: '5px 22px',
        },
        '@media screen and (min-width: 1024px)': {
            padding: '5px 30px',
            margin: '0 10px 0 0',
        },
    },
    secondaryButtonStyle: {
        backgroundColor: 'transparent',
        color: theme.palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '9px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.black}`,
        boxShadow: 'none',
        margin: '16px 6px 0 0',
        '@media screen and (max-width: 400px)': {
            fontSize: '12px',
            padding: '5px 16px',
        },
        '@media screen and (min-width: 768px)': {
            fontSize: '16px',
            padding: '5px 22px',
        },
        '@media screen and (min-width: 1024px)': {
            padding: '5px 30px',
            margin: '0 10px 0 0',
        },
    },
    statusChipContainer: {
        display: 'flex',
        flexFlow: 'wrap',
    },
});

class SubscriptionStatusChips extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            classes, subscription, handleCancelModal, handleSkipModal, handlePauseModal, handleResumeModal,
        } = this.props;
        const PAY_UP_FRONT_ORDER = subscription?.subscriptionType?.toLowerCase() === 'monthonlypayfull';

        return (
            <div className={classes.statusChipContainer}>
                {['PROCESSED', 'UPDATED', 'SKIPPED', 'RESUMED'].includes(subscription.subscriptionStatus)
                    ? (
                        <>
                            <Button
                                className={classes.secondaryButtonStyle}
                                variant="contained"
                                align="center"
                                raised="true"
                                disabled={PAY_UP_FRONT_ORDER}
                                onClick={() => handlePauseModal(true, subscription.ruleId)}
                            >
                                Pause
                            </Button>
                            <Button
                                className={classes.secondaryButtonStyle}
                                variant="contained"
                                align="center"
                                raised="true"
                                disabled={PAY_UP_FRONT_ORDER}
                                onClick={() => handleSkipModal(true, subscription.ruleId)}
                            >
                                Skip
                            </Button>
                        </>
                    )
                    : (
                        <Button
                            className={classes.primaryButtonActive}
                            variant="contained"
                            align="center"
                            raised="true"
                            disabled={PAY_UP_FRONT_ORDER}
                            onClick={() => handleResumeModal(true, subscription.ruleId)}
                        >
                            Resume
                        </Button>
                    )}
                <Button
                    className={classes.secondaryButtonStyle}
                    variant="contained"
                    align="center"
                    raised="true"
                    disabled={PAY_UP_FRONT_ORDER}
                    onClick={() => handleCancelModal(true, subscription.ruleId, 'Cancel')}
                >
                    Cancel
                </Button>
            </div>
        );
    }
}

SubscriptionStatusChips.propTypes = {
    classes: object.isRequired,
    subscription: object.isRequired,
    handleCancelModal: func.isRequired,
    handleSkipModal: func.isRequired,
    handlePauseModal: func.isRequired,
    handleResumeModal: func.isRequired,
};

export default withStyles(styles, { withTheme: true })(SubscriptionStatusChips);
